import { APIResponse } from '../../../../@types/api-response';
import { bondsEndpoints } from '../constants/apiEndpoint';
import {
  BondBuyPreviewResponse,
  BondOrder,
  BondPortfolioDetailResponse,
  BondPortfolioListResponse,
  BondSellPreviewResponse,
  BondsBuyForm,
  BondsBuyPreviewQuery,
  BondsSellForm,
  BondsSellPreviewQuery,
} from '../types/api/bond';
import { getTradingApiInstance } from './instance/trading';

export const postBondBuy = async (
  form: BondsBuyForm,
): Promise<APIResponse<{ message: string }>> =>
  getTradingApiInstance().post(bondsEndpoints.postBuy, form);

export const getBondBuyPreview = async (
  params: BondsBuyPreviewQuery,
): Promise<APIResponse<BondBuyPreviewResponse>> =>
  getTradingApiInstance().get(bondsEndpoints.getBuyPreview, {
    params,
  });

export const postBondSell = async (
  form: BondsSellForm,
): Promise<APIResponse<{ message: string }>> =>
  getTradingApiInstance().post(bondsEndpoints.postSell, form);

export const getBondSellPreview = async (
  params: BondsSellPreviewQuery,
): Promise<APIResponse<BondSellPreviewResponse>> =>
  getTradingApiInstance().get(bondsEndpoints.getSellPreview, {
    params,
  });

export const getBondOrderList = async (): Promise<
  APIResponse<{ orders: BondOrder[] }>
> => getTradingApiInstance().get(bondsEndpoints.getOrderList);

export const getBondOrderDetail = async (
  orderId: string,
): Promise<APIResponse<{ order: BondOrder }>> =>
  getTradingApiInstance().get(bondsEndpoints.getOrderDetail(orderId));

export const getBondPortfolioList = async (): Promise<
  APIResponse<BondPortfolioListResponse>
> => getTradingApiInstance().get(bondsEndpoints.getPortfolioList);

export const getBondPortfolioDetail = async (
  orderId: string,
  withCouponHistories = false,
): Promise<APIResponse<BondPortfolioDetailResponse>> =>
  getTradingApiInstance().get(bondsEndpoints.getPortfolioDetail(orderId), {
    params: {
      with_coupon_histories: withCouponHistories ? 1 : 0,
    },
  });
